// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__27_M4","content":"GlobalSearch_content__2X4jb"};